import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Block } from '@sorare/core/src/atoms/layout/Block';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS } from '@sorare/core/src/atoms/typography';
import { NewsTitleContent } from '@sorare/core/src/components/player/News/NewsTitleContent';
import { NewsUpdates } from '@sorare/core/src/components/player/News/NewsUpdates';

import type { PlayerNewsUpdates_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  player: PlayerNewsUpdates_anyPlayer;
};

export const PlayerNewsUpdates = ({ player }: Props) => {
  if (!player.news.length) return null;

  return (
    <Vertical>
      <HeadlineS as="h5">
        <NewsTitleContent />
      </HeadlineS>
      <Block>
        <NewsUpdates
          updates={player.news}
          playerName={player.displayName}
          hideAnalysis
        />
      </Block>
    </Vertical>
  );
};

PlayerNewsUpdates.fragments = {
  anyPlayer: gql`
    fragment PlayerNewsUpdates_anyPlayer on AnyPlayerInterface {
      slug
      displayName
      news(last: 10) {
        ...NewsUpdates_PlayerNewsUpdate
      }
    }
    ${NewsUpdates.fragments.PlayerNewsUpdate}
  ` as TypedDocumentNode<PlayerNewsUpdates_anyPlayer>,
};
